@if (!completed) {
  <div class="skill-test text-center" [class.invalid]="control().invalid && submitAttempt()">
    <p
    [innerHTML]="
      'jobboard.snippets.skill-test.question'
        | transloco
          : {
              question: index + 1,
              length: questions.length
            }
    "
  ></p>
  @if (showIntroQuestion()) {
    <p class="mt-3">{{ 'ct-library.isa.questions.main' | transloco }}</p>
  }
  <div class="row mt-3">
    <div class="col-6 left-word">
      <p>{{ questions[index].left | transloco }}</p>
    </div>
    <div class="col-6 right-word">
      <p>{{ questions[index].right | transloco }}</p>
    </div>
    <div class="col-12 mt-2">
      <div class="slider" [class]="'s' + value">
        <div class="points">
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
        </div>
        <input type="range" min="1" max="5" [(ngModel)]="value" #indicator (change)="sliderChange($event)" />
      </div>
    </div>
  </div>
  <div class="buttons">
    @if (index > 0 && index < questions.length) {
      <button class="ct-btn ct-btn-themed prev" (click)="prev()">
        {{ 'jobboard.snippets.skill-test.previous' | transloco }}
      </button>
    }
    @if (index < questions.length - 1) {
      <button
        class="ct-btn ct-btn-themed next"
        [class.disabled]="value === 3"
        [tooltip]="value === 3 ? ('jobboard.snippets.skill-test.no-answer-tooltip' | transloco) : undefined"
        (click)="value === 3 ? null : next()"
        >
        {{ 'jobboard.snippets.skill-test.next' | transloco }}
      </button>
    }
    @if(index === questions.length - 1) {
      <button
        class="ct-btn ct-btn-themed-solid next"
        [class.disabled]="value === 3"
        [tooltip]="value === 3 ? ('jobboard.snippets.skill-test.no-answer-tooltip' | transloco) : undefined"
        (click)="finish()"
        >
        {{ 'jobboard.snippets.skill-test.finish' | transloco }}
      </button>
    }
  </div>
</div>
}
@if (completed) {
  <div>
    <app-animated-check [color]="colorService.accent"></app-animated-check>
  </div>
}
